export default "__VITE_ASSET__45$JPEWU__"